<p-toast position="top-center"></p-toast>
<app-page-shell *ngIf="purchaseOrder">
    <app-page-detail-hero [auditStamp]="purchaseOrder"
        eyebrow="Purchase Order"
        [title]="purchaseOrder.purchaseOrderNumber || 'Purchase Order'"
        [subtitle]="heroSubtitle()"
        icon="pi pi-shopping-cart">
        <div tags class="order-hero-tags">
            <div class="order-hero-status">
                <span>Procurement Status</span>
                <strong>{{ getStatusLabel(purchaseOrder.state) }}</strong>
            </div>
            <div class="order-hero-meta-tags">
                <p-tag [value]="getStatusLabel(getApprovalStatus())" [severity]="getStatusSeverity(getApprovalStatus())" [pTooltip]="getStatusTooltip(getApprovalStatus())"></p-tag>
                <p-tag [value]="getStatusLabel(getReceivingStatus())" [severity]="getStatusSeverity(getReceivingStatus())" [pTooltip]="getStatusTooltip(getReceivingStatus())"></p-tag>
                <p-tag [value]="getStatusLabel(getBillingStatus())" [severity]="getStatusSeverity(getBillingStatus())" [pTooltip]="getStatusTooltip(getBillingStatus())"></p-tag>
                <p-tag [value]="getStatusLabel(getMatchingStatus())" [severity]="getStatusSeverity(getMatchingStatus())" [pTooltip]="getStatusTooltip(getMatchingStatus())"></p-tag>
                <p-tag [value]="getStatusLabel(getHoldStatus())" [severity]="getStatusSeverity(getHoldStatus())" [pTooltip]="getStatusTooltip(getHoldStatus())"></p-tag>
                <p-tag *ngIf="hasLogisticsProject()" value="Project linked" severity="info"></p-tag>
            </div>
        </div>
        <div actions>
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/order/purchase-order"></p-button>
        </div>
    </app-page-detail-hero>

    <div class="order-detail-layout">
        <main class="order-detail-main">
            <app-page-metric-strip [metrics]="detailMetrics()"></app-page-metric-strip>

            <app-page-data-panel title="Purchase Order Workspace" [subtitle]="getVendorName() + ' | ' + formatMoney(getTotalAmount())" [resultText]="getLineCount() + ' lines'">
        <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange($event)" styleClass="order-workspace-tabs">
            <p-tablist>
                <p-tab [value]="0"><span class="workspace-tab"><i class="pi pi-compass"></i><span>Overview</span></span></p-tab>
                <p-tab [value]="1"><span class="workspace-tab"><i class="pi pi-list-check"></i><span>Lines</span><span class="workspace-badge">{{ getLineCount() }}</span></span></p-tab>
                <p-tab [value]="2"><span class="workspace-tab"><i class="pi pi-shield"></i><span>Approvals</span></span></p-tab>
                <p-tab [value]="3"><span class="workspace-tab"><i class="pi pi-box"></i><span>Receipts</span></span></p-tab>
                <p-tab [value]="4"><span class="workspace-tab"><i class="pi pi-sliders-h"></i><span>Matching</span></span></p-tab>
                <p-tab [value]="5"><span class="workspace-tab"><i class="pi pi-receipt"></i><span>Vendor Bills</span></span></p-tab>
                <p-tab [value]="6"><span class="workspace-tab"><i class="pi pi-history"></i><span>Audit</span><span class="workspace-badge">{{ activity.length }}</span></span></p-tab>
                <p-tab [value]="7"><span class="workspace-tab"><i class="pi pi-paperclip"></i><span>Notes &amp; Files</span><span class="workspace-badge">{{ purchaseAttachments.length }}</span></span></p-tab>
            </p-tablist>

            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <section class="order-workspace-section">
                        <div class="order-route-board">
                            <div class="order-route-endpoint">
                                <span class="endpoint-kicker">{{ crmActive() ? 'CRM Client' : 'Supplier' }}</span>
                                <h3>{{ getVendorName() }}</h3>
                                <p>{{ purchaseOrder.shippingAddress || 'Delivery address pending' }}</p>
                            </div>
                            <div class="order-route-connector">
                                <span></span>
                                <i class="pi pi-shopping-cart"></i>
                                <span></span>
                            </div>
                            <div class="order-route-endpoint destination">
                                <span class="endpoint-kicker">Purchase Order</span>
                                <h3>{{ purchaseOrder.purchaseOrderNumber || '-' }}</h3>
                                <p *ngIf="purchaseOrder.externalReferenceNumber || purchaseOrder.supplierReference">Ref: <strong>{{ purchaseOrder.externalReferenceNumber || purchaseOrder.supplierReference }}</strong></p>
                                <p>{{ purchaseOrder.expectedDate ? (purchaseOrder.expectedDate | date:'mediumDate') : 'Expected date pending' }}</p>
                            </div>
                        </div>

                        <div class="order-summary-grid">
                            <div><span>Commercial</span><strong>{{ getStatusLabel(purchaseOrder.state) }}</strong></div>
                            <div><span>Approval</span><strong>{{ getStatusLabel(getApprovalStatus()) }}</strong></div>
                            <div><span>Receiving</span><strong>{{ getStatusLabel(getReceivingStatus()) }}</strong></div>
                            <div><span>Billing</span><strong>{{ getStatusLabel(getBillingStatus()) }}</strong></div>
                            <div><span>Matching</span><strong>{{ getStatusLabel(getMatchingStatus()) }}</strong></div>
                            <div><span>Hold</span><strong>{{ getStatusLabel(getHoldStatus()) }}</strong></div>
                        </div>

                        <div class="workspace-grid">
                            <section class="workspace-section span-8">
                                <div class="section-heading">
                                    <i class="pi pi-building"></i>
                                    <div>
                                        <h3>Procurement Header</h3>
                                        <p>{{ purchaseOrder.purchaseOrderNumber || '-' }}</p>
                                    </div>
                                </div>
                                <div class="detail-grid">
                                    <div><span>Supplier</span><strong>{{ getVendorName() }}</strong></div>
                                    <div><span>{{ getCompanyOrCrmLabel() }}</span><strong>{{ getCompanyOrCrmValue() }}</strong></div>
                                    @if (crmActive()) {
                                    <div><span>CRM Contact</span><strong>{{ selectedCrmContactLabel() }}</strong></div>
                                    }
                                    <div><span>Payment Term</span><strong>{{ purchaseOrder.paymentTerm?.name || '-' }}</strong></div>
                                    <div><span>Order Date</span><strong>{{ purchaseOrder.orderDate ? (purchaseOrder.orderDate | date:'mediumDate') : '-' }}</strong></div>
                                    <div><span>Expected Date</span><strong>{{ purchaseOrder.expectedDate ? (purchaseOrder.expectedDate | date:'mediumDate') : '-' }}</strong></div>
                                    <div><span>Promised Date</span><strong>{{ purchaseOrder.promisedDate ? (purchaseOrder.promisedDate | date:'mediumDate') : '-' }}</strong></div>
                                    <div><span>Supplier Confirmation</span><strong>{{ purchaseOrder.supplierConfirmationStatus || '-' }}</strong></div>
                                    <div><span>Currency</span><strong>{{ currencyCode }}</strong></div>
                                    <div><span>Exchange Rate</span><strong>{{ purchaseOrder.exchangeRate || 1 }}</strong></div>
                                    <div><span>Version</span><strong>{{ purchaseOrder.versionNumber ?? '-' }}</strong></div>
                                    <div><span>Department</span><strong>{{ purchaseOrder.department || '-' }}</strong></div>
                                    <div><span>Cost Center</span><strong>{{ purchaseOrder.costCenter || '-' }}</strong></div>
                                    <div><span>Procurement Category</span><strong>{{ purchaseOrder.procurementCategory || '-' }}</strong></div>
                                    <div><span>Project Reference</span><strong>{{ purchaseOrder.projectReference || '-' }}</strong></div>
                                    <div><span>Supplier / External Ref</span><strong>{{ purchaseOrder.externalReferenceNumber || purchaseOrder.supplierReference || '-' }}</strong></div>
                                    <div><span>Supplier Contact</span><strong>{{ purchaseOrder.supplierContact || '-' }}</strong></div>
                                    <div><span>Incoterms</span><strong>{{ purchaseOrder.incoterms || '-' }}</strong></div>
                                    <div><span>Delivery Terms</span><strong>{{ purchaseOrder.deliveryTerms || '-' }}</strong></div>
                                    <div><span>Logistics Project</span><strong>
                                        @if (purchaseOrder.logisticsProjectId) {
                                            <a [routerLink]="['/logistics-projects', purchaseOrder.logisticsProjectId]">{{ logisticsProjectName(purchaseOrder.logisticsProjectId) }}</a>
                                        } @else { - }
                                    </strong></div>
                                </div>
                            </section>

                            <section class="workspace-section span-4">
                                <div class="section-heading">
                                    <i class="pi pi-map-marker"></i>
                                    <div>
                                        <h3>Addresses</h3>
                                        <p>Delivery and billing context</p>
                                    </div>
                                </div>
                                <div class="address-stack">
                                    <div>
                                        <span>Shipping</span>
                                        <strong>{{ purchaseOrder.shippingAddress || '-' }}</strong>
                                    </div>
                                    <div>
                                        <span>Billing</span>
                                        <strong>{{ purchaseOrder.billingAddress || '-' }}</strong>
                                    </div>
                                </div>
                            </section>

                            <section class="workspace-section span-12" *ngIf="hasHeaderFlexFields()">
                                <div class="section-heading">
                                    <i class="pi pi-sliders-h"></i>
                                    <div>
                                        <h3>Custom Fields</h3>
                                        <p>Header-specific procurement attributes</p>
                                    </div>
                                </div>
                                <app-flex-field-view
                                    [flexFields]="getHeaderFlexFields()"
                                    containerClass="grid"
                                    [isHeaderFields]="true"
                                    itemClass="col-12 md:col-6 lg:col-4">
                                </app-flex-field-view>
                            </section>
                        </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="1">
                    <section class="order-workspace-section">
                        <div class="line-layout">
                            <div class="line-table">
                                <p-table [value]="getLines()" styleClass="p-datatable-sm order-lines-table" [tableStyle]="{ 'min-width': '66rem' }">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>Line</th>
                                            <th>Product</th>
                                            <th class="text-right">Qty</th>
                                            <th class="text-right">Unit</th>
                                            <th class="text-right">Tax</th>
                                            <th class="text-right">Total</th>
                                            <th>Project</th>
                                            <th>Pricing</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-line>
                                        <tr>
                                            <td><strong>{{ line.lineNumber || '-' }}</strong></td>
                                            <td>
                                                <div class="line-title">{{ line.product?.name || line.description || 'Purchase line' }}</div>
                                                <div class="line-subtitle">{{ line.variant?.name || line.description || '-' }}</div>
                                                <app-flex-field-view *ngIf="getLineFlexFields(line).length"
                                                    [flexFields]="getLineFlexFields(line)"
                                                    [isHeaderFields]="false"
                                                    containerClass="mt-2 text-sm"
                                                    itemClass="text-sm">
                                                </app-flex-field-view>
                                            </td>
                                            <td class="text-right">{{ line.quantity | number:'1.0-2' }}</td>
                                            <td class="text-right">{{ line.unitPrice | currency:currencyCode:'symbol' : '1.4-4' }}</td>
                                            <td class="text-right">
                                                <strong>{{ line.totalTax | currency:currencyCode:'symbol' }}</strong>
                                                <small>{{ getLineTaxLabel(line) }}</small>
                                            </td>
                                            <td class="text-right"><strong>{{ getLineTotal(line) | currency:currencyCode:'symbol' }}</strong></td>
                                            <td>
                                                @if (line.logisticsProjectId || purchaseOrder.logisticsProjectId) {
                                                    <a [routerLink]="['/logistics-projects', line.logisticsProjectId || purchaseOrder.logisticsProjectId]">{{ logisticsProjectName(line.logisticsProjectId || purchaseOrder.logisticsProjectId) }}</a>
                                                } @else { <span class="text-500">-</span> }
                                            </td>
                                            <td>
                                                <p-tag [value]="line.priceSource || 'MANUAL'" severity="secondary"></p-tag>
                                                <p-tag *ngIf="line.manualPriceOverride" value="Override" severity="warn" class="ml-2"></p-tag>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr><td colspan="8" class="text-center p-4">No purchase order lines found.</td></tr>
                                    </ng-template>
                                </p-table>
                            </div>

                            <aside class="totals-rail">
                                <div><span>Subtotal</span><strong>{{ getSubTotal() | currency:currencyCode:'symbol' }}</strong></div>
                                <div><span>Discount</span><strong>{{ getDiscountAmount() | currency:currencyCode:'symbol' }}</strong></div>
                                <div><span>Tax</span><strong>{{ getTotalTax() | currency:currencyCode:'symbol' }}</strong></div>
                                <div class="grand"><span>Total</span><strong>{{ getTotalAmount() | currency:currencyCode:'symbol' }}</strong></div>
                            </aside>
                        </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="2">
                    <section class="order-workspace-section">
                        <div class="status-board procurement">
                            <section>
                                <i class="pi pi-check-circle"></i>
                                <span>Commercial</span>
                                <p-tag [value]="getStatusLabel(purchaseOrder.state)" [severity]="getStatusSeverity(purchaseOrder.state)"></p-tag>
                            </section>
                            <section>
                                <i class="pi pi-shield"></i>
                                <span>Approval</span>
                                <p-tag [value]="getStatusLabel(getApprovalStatus())" [severity]="getStatusSeverity(getApprovalStatus())"></p-tag>
                            </section>
                            <section>
                                <i class="pi pi-envelope"></i>
                                <span>Supplier Confirmation</span>
                                <p-tag [value]="purchaseOrder.supplierConfirmationStatus || 'PENDING'" severity="secondary"></p-tag>
                            </section>
                            <section>
                                <i class="pi pi-lock-open"></i>
                                <span>Hold</span>
                                <p-tag [value]="getStatusLabel(getHoldStatus())" [severity]="getStatusSeverity(getHoldStatus())"></p-tag>
                            </section>
                        </div>

                        <div class="workspace-grid">
                            <section class="workspace-section span-7">
                                <div class="section-heading">
                                    <i class="pi pi-verified"></i>
                                    <div>
                                        <h3>Approval Workbench</h3>
                                        <p>Lifecycle actions available for this purchase order</p>
                                    </div>
                                </div>
                                <div class="detail-grid">
                                    <div><span>Current State</span><strong>{{ purchaseOrder.state || '-' }}</strong></div>
                                    <div><span>Approval Status</span><strong>{{ getApprovalStatus() }}</strong></div>
                                    <div><span>Available Actions</span><strong>{{ purchaseActionMetadata?.availableActions?.join(', ') || 'No actions available' }}</strong></div>
                                    <div><span>Reason Required</span><strong>{{ purchaseActionMetadata?.requiresReason?.join(', ') || 'No' }}</strong></div>
                                </div>
                                <div class="notes-actions mt-3">
                                    <p-button *ngIf="canRunAction('SUBMIT')" label="Submit" icon="pi pi-send" severity="secondary" [outlined]="true" (click)="openAction('SUBMIT')" [disabled]="actionLoading"></p-button>
                                    <p-button *ngIf="canRunAction('APPROVE')" label="Approve" icon="pi pi-check-circle" severity="success" [outlined]="true" (click)="openAction('APPROVE')" [disabled]="actionLoading"></p-button>
                                    <p-button *ngIf="canRunAction('REJECT')" label="Reject" icon="pi pi-times-circle" severity="danger" [outlined]="true" (click)="openAction('REJECT')" [disabled]="actionLoading"></p-button>
                                    <p-button *ngIf="canRunAction('CONFIRM')" label="Confirm" icon="pi pi-verified" (click)="openAction('CONFIRM')" [disabled]="actionLoading"></p-button>
                                    <p-button *ngIf="canRunAction('SEND_TO_SUPPLIER')" label="Send to Supplier" icon="pi pi-envelope" severity="info" [outlined]="true" (click)="openAction('SEND_TO_SUPPLIER')" [disabled]="actionLoading"></p-button>
                                    <p-button *ngIf="canRunAction('ACKNOWLEDGE')" label="Acknowledge" icon="pi pi-check-square" severity="secondary" [outlined]="true" (click)="openAction('ACKNOWLEDGE')" [disabled]="actionLoading"></p-button>
                                    <p-button *ngIf="canRunAction('HOLD')" label="Hold" icon="pi pi-lock" severity="warn" [outlined]="true" (click)="openAction('HOLD')" [disabled]="actionLoading"></p-button>
                                    <p-button *ngIf="canRunAction('RELEASE_HOLD')" label="Release Hold" icon="pi pi-lock-open" severity="info" [outlined]="true" (click)="openAction('RELEASE_HOLD')" [disabled]="actionLoading"></p-button>
                                    <p-button *ngIf="canRunAction('CLOSE')" label="Close" icon="pi pi-check" severity="secondary" [outlined]="true" (click)="openAction('CLOSE')" [disabled]="actionLoading"></p-button>
                                    <p-button *ngIf="canRunAction('CANCEL')" label="Cancel" icon="pi pi-ban" severity="danger" [outlined]="true" (click)="openAction('CANCEL')" [disabled]="actionLoading"></p-button>
                                </div>
                            </section>

                            <section class="workspace-section span-5">
                                <div class="section-heading">
                                    <i class="pi pi-list"></i>
                                    <div>
                                        <h3>Action Guide</h3>
                                        <p>Use the approval sequence before supplier release</p>
                                    </div>
                                </div>
                                <div class="address-stack">
                                    <div>
                                        <span>Submit</span>
                                        <strong>Moves a draft into approval review.</strong>
                                    </div>
                                    <div>
                                        <span>Approve / Reject</span>
                                        <strong>Controls commercial release for procurement.</strong>
                                    </div>
                                    <div>
                                        <span>Confirm / Send</span>
                                        <strong>Finalizes and shares the PO with the supplier.</strong>
                                    </div>
                                    <div>
                                        <span>Hold / Release / Close</span>
                                        <strong>Manages exceptions and end-of-life controls.</strong>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="3">
                    <section class="order-workspace-section">
                        <div class="flex justify-content-between align-items-center mb-3">
                            <div><h3 class="m-0">Goods Receipts</h3><p class="text-secondary m-0">Container-linked GRNs and quality-hold stock history.</p></div>
                            <p-button label="Receive against PO" icon="pi pi-plus" (click)="createReceipt()"></p-button>
                        </div>
                        <p-table [value]="purchaseReceipts" styleClass="p-datatable-sm" [tableStyle]="{'min-width':'48rem'}">
                            <ng-template pTemplate="header"><tr><th>GRN</th><th>Date</th><th>Warehouse</th><th>Container</th><th>Status</th><th>Lines</th><th></th></tr></ng-template>
                            <ng-template pTemplate="body" let-receipt><tr>
                                <td><strong>{{ receipt.receiptNumber }}</strong></td><td>{{ receipt.receivedDate | date:'mediumDate' }}</td>
                                <td>{{ receipt.warehouseId }}</td><td>{{ receipt.containerCaseId || '-' }}</td>
                                <td><p-tag [value]="receipt.status || 'DRAFT'" [severity]="receipt.status === 'CONFIRMED' ? 'success' : 'warn'"></p-tag></td>
                                <td>{{ receipt.lines?.length || 0 }}</td><td><p-button icon="pi pi-eye" [text]="true" (click)="viewReceipt(receipt)"></p-button></td>
                            </tr></ng-template>
                            <ng-template pTemplate="emptymessage"><tr><td colspan="7" class="text-center p-4">No receipts yet. Use Receive against PO to create the first GRN.</td></tr></ng-template>
                        </p-table>
                        <div class="workspace-grid">
                            <section class="workspace-section span-5">
                                <div class="section-heading">
                                    <i class="pi pi-box"></i>
                                    <div>
                                        <h3>Receipt Readiness</h3>
                                        <p>Order-level receiving state and supplier commitments</p>
                                    </div>
                                </div>
                                <div class="detail-grid">
                                    <div><span>Receiving Status</span><strong>{{ getStatusLabel(getReceivingStatus()) }}</strong></div>
                                    <div><span>Expected Date</span><strong>{{ purchaseOrder.expectedDate ? (purchaseOrder.expectedDate | date:'mediumDate') : '-' }}</strong></div>
                                    <div><span>Promised Date</span><strong>{{ purchaseOrder.promisedDate ? (purchaseOrder.promisedDate | date:'mediumDate') : '-' }}</strong></div>
                                    <div><span>Supplier Confirmation</span><strong>{{ purchaseOrder.supplierConfirmationStatus || '-' }}</strong></div>
                                    <div><span>Delivery Terms</span><strong>{{ purchaseOrder.deliveryTerms || '-' }}</strong></div>
                                    <div><span>Shipping Address</span><strong>{{ purchaseOrder.shippingAddress || '-' }}</strong></div>
                                </div>
                            </section>

                            <section class="workspace-section span-7">
                                <div class="section-heading">
                                    <i class="pi pi-truck"></i>
                                    <div>
                                        <h3>Receipt Scope</h3>
                                        <p>Lines pending physical receipt or service acceptance</p>
                                    </div>
                                </div>
                                <p-table [value]="getLines()" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '42rem' }">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>Line</th>
                                            <th>Product</th>
                                            <th class="text-right">Qty</th>
                                            <th class="text-right">Line Total</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-line>
                                        <tr>
                                            <td>{{ line.lineNumber || '-' }}</td>
                                            <td>{{ line.product?.name || line.description || 'Purchase line' }}</td>
                                            <td class="text-right">{{ line.quantity | number:'1.0-2' }}</td>
                                            <td class="text-right">{{ getLineTotal(line) | currency:currencyCode:'symbol' }}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </section>
                        </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="4">
                    <section class="order-workspace-section">
                        <div class="workspace-grid">
                            <section class="workspace-section span-5">
                                <div class="section-heading">
                                    <i class="pi pi-sliders-h"></i>
                                    <div>
                                        <h3>Matching Control</h3>
                                        <p>PO amount, receipt state, and payable verification context</p>
                                    </div>
                                </div>
                                <div class="detail-grid">
                                    <div><span>Matching Status</span><strong>{{ getStatusLabel(getMatchingStatus()) }}</strong></div>
                                    <div><span>Billing Status</span><strong>{{ getStatusLabel(getBillingStatus()) }}</strong></div>
                                    <div><span>Receiving Status</span><strong>{{ getStatusLabel(getReceivingStatus()) }}</strong></div>
                                    <div><span>Order Total</span><strong>{{ getTotalAmount() | currency:currencyCode:'symbol' }}</strong></div>
                                    <div><span>Tax</span><strong>{{ getTotalTax() | currency:currencyCode:'symbol' }}</strong></div>
                                    <div><span>Supplier / External Ref</span><strong>{{ purchaseOrder.externalReferenceNumber || purchaseOrder.supplierReference || '-' }}</strong></div>
                                </div>
                                <div class="notes-actions mt-3">
                                    <p-button label="Matching Dashboard" icon="pi pi-external-link" severity="secondary" [outlined]="true" (click)="openMatchingDashboard()"></p-button>
                                </div>
                            </section>

                            <section class="workspace-section span-7">
                                <div class="section-heading">
                                    <i class="pi pi-calculator"></i>
                                    <div>
                                        <h3>Line Value Matrix</h3>
                                        <p>Reference amounts for invoice verification</p>
                                    </div>
                                </div>
                                <p-table [value]="getLines()" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '42rem' }">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>Line</th>
                                            <th>Product</th>
                                            <th class="text-right">Base</th>
                                            <th class="text-right">Tax</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-line>
                                        <tr>
                                            <td>{{ line.lineNumber || '-' }}</td>
                                            <td>{{ line.product?.name || line.description || 'Purchase line' }}</td>
                                            <td class="text-right">{{ getLineBaseAmount(line) | currency:currencyCode:'symbol' }}</td>
                                            <td class="text-right">{{ (line.totalTax || 0) | currency:currencyCode:'symbol' }}</td>
                                            <td class="text-right">{{ getLineTotal(line) | currency:currencyCode:'symbol' }}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </section>
                        </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="5">
                    <section class="order-workspace-section">
                        <div class="workspace-grid">
                            <section class="workspace-section span-6">
                                <div class="section-heading">
                                    <i class="pi pi-receipt"></i>
                                    <div>
                                        <h3>Vendor Bill Readiness</h3>
                                        <p>Payables handoff from the purchase order</p>
                                    </div>
                                </div>
                                <div class="notes-actions mb-3">
                                    <p-button [label]="vendorBillReadiness?.payableId ? 'Update Accounts' : 'Post To Accounts'" icon="pi pi-file-plus" severity="success"
                                        (click)="postToAccounts()" [loading]="payableStagingLoading"
                                        [disabled]="!canPostToAccounts()"
                                        [pTooltip]="canPostToAccounts() ? 'Stage the purchase order in To Bill' : (vendorBillReadiness?.blockingReasons?.[0] || 'Resolve readiness blockers before posting to accounts')"></p-button>
                                </div>
                                @if (vendorBillReadiness?.blockingReasons?.length) {
                                    <div class="control-alerts mb-3">
                                        @for (reason of vendorBillReadiness?.blockingReasons; track reason) {
                                            <div class="control-alert warn"><i class="pi pi-exclamation-triangle"></i><span>{{ reason }}</span></div>
                                        }
                                    </div>
                                }
                                @if (vendorBillReadiness?.payableId) {
                                    <div class="mb-3 flex gap-3 flex-wrap">
                                        <a [routerLink]="['/accounts/enterprise/payables/to-be-billed/view', vendorBillReadiness?.payableId]">View payable</a>
                                        @if (vendorBillReadiness?.billId) {
                                            <a [routerLink]="['/accounts/enterprise/payables/generated-bills/view', vendorBillReadiness?.billId]">View bill {{ vendorBillReadiness?.billNumber }}</a>
                                        }
                                    </div>
                                }
                                <div class="detail-grid">
                                    <div><span>Readiness</span><strong>{{ vendorBillReadiness?.ready ? 'Ready to bill' : 'Not ready' }}</strong></div>
                                    <div><span>Billing Status</span><strong>{{ getStatusLabel(getBillingStatus()) }}</strong></div>
                                    <div><span>Matching Status</span><strong>{{ getStatusLabel(getMatchingStatus()) }}</strong></div>
                                    <div><span>Supplier</span><strong>{{ getVendorName() }}</strong></div>
                                    <div><span>Net Amount</span><strong>{{ (vendorBillReadiness?.totalNetAmount ?? 0) | currency:currencyCode:'symbol' }}</strong></div>
                                    <div><span>Tax</span><strong>{{ (vendorBillReadiness?.totalTaxAmount ?? 0) | currency:currencyCode:'symbol' }}</strong></div>
                                    <div><span>Total Exposure</span><strong>{{ (vendorBillReadiness?.totalAmount ?? getTotalAmount()) | currency:currencyCode:'symbol' }}</strong></div>
                                    <div><span>Reference</span><strong>{{ purchaseOrder.supplierReference || purchaseOrder.purchaseOrderNumber || '-' }}</strong></div>
                                    <div><span>Approval</span><strong>{{ getStatusLabel(getApprovalStatus()) }}</strong></div>
                                    @if (vendorBillReadiness?.billNumber) {
                                        <div><span>Draft Bill</span><strong>{{ vendorBillReadiness?.billNumber }}</strong></div>
                                    }
                                </div>
                            </section>

                            <section class="workspace-section span-6">
                                <div class="section-heading">
                                    <i class="pi pi-arrow-right-arrow-left"></i>
                                    <div>
                                        <h3>Payables Links</h3>
                                        <p>Open the enterprise payables workbench from this PO</p>
                                    </div>
                                </div>
                                <div class="notes-actions">
                                    <p-button label="Vendor Bills" icon="pi pi-external-link" severity="secondary" [outlined]="true" (click)="openVendorBills()"></p-button>
                                    <p-button label="Matching Dashboard" icon="pi pi-external-link" severity="secondary" [outlined]="true" (click)="openMatchingDashboard()"></p-button>
                                </div>
                                <div class="address-stack mt-3">
                                    <div>
                                        <span>Bill Workflow</span>
                                        <strong>Use the vendor-bill workbench for draft, approval, and posting.</strong>
                                    </div>
                                    <div>
                                        <span>Matching Workflow</span>
                                        <strong>Use AP matching for tolerance checks and exception handling.</strong>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="6">
                    <section class="order-workspace-section">
                        <div class="audit-layout">
                            <section class="workspace-section">
                                <div class="section-heading">
                                    <i class="pi pi-user-edit"></i>
                                    <div>
                                        <h3>Order metadata</h3>
                                        <p>Confirmation and version</p>
                                    </div>
                                </div>
                                <div class="detail-grid compact">
                                    <div><span>Confirmed</span><strong>{{ purchaseOrder.confirmedAt ? (purchaseOrder.confirmedAt | date:'medium') : '-' }}</strong></div>
                                    <div><span>Version</span><strong>{{ purchaseOrder.versionNumber ?? '-' }}</strong><small>Optimistic contract version</small></div>
                                </div>
                            </section>

                            <section class="workspace-section">
                                <div class="section-heading">
                                    <i class="pi pi-history"></i>
                                    <div>
                                        <h3>Activity</h3>
                                        <p>{{ activity.length }} events</p>
                                    </div>
                                </div>
                                <div class="timeline" *ngIf="activity.length; else noPurchaseActivity">
                                    <div class="timeline-item" *ngFor="let item of activity">
                                        <div class="timeline-dot"></div>
                                        <div>
                                            <strong>{{ item.eventType }}</strong>
                                            <p>{{ item.message || '-' }}</p>
                                            <small>{{ item.createdAt | date:'medium' }} | By {{ item.actor?.name || item.actorName || '-' }}</small>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #noPurchaseActivity>
                                    <div class="empty-state">No activity recorded.</div>
                                </ng-template>
                            </section>
                        </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="7">
                    <section class="order-workspace-section">
                        <div class="workspace-grid">
                            <section class="workspace-section span-7">
                                <div class="section-heading">
                                    <i class="pi pi-align-left"></i>
                                    <div>
                                        <h3>Internal Notes</h3>
                                        <p>Procurement context</p>
                                    </div>
                                </div>
                                <div class="notes-panel flat">
                                    @if (notesEditing) {
                                        <p-editor
                                            [(ngModel)]="notesDraft"
                                            name="purchaseOrderNotesDraft"
                                            styleClass="order-rich-editor"
                                            [style]="{ height: '220px' }">
                                        </p-editor>
                                        <div class="notes-actions">
                                            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="cancelNotesEdit()" [disabled]="notesSaving"></p-button>
                                            <p-button label="Save Notes" icon="pi pi-save" (click)="saveNotes()" [loading]="notesSaving"></p-button>
                                        </div>
                                    } @else if (purchaseOrder.notes) {
                                        <div class="rich-html" [innerHTML]="purchaseOrder.notes"></div>
                                        <div class="notes-actions">
                                            <p-button label="Edit Notes" icon="pi pi-pencil" severity="secondary" [outlined]="true" (click)="startNotesEdit()"></p-button>
                                        </div>
                                    } @else {
                                        <p>No notes for this order.</p>
                                        <div class="notes-actions">
                                            <p-button label="Add Notes" icon="pi pi-pencil" severity="secondary" [outlined]="true" (click)="startNotesEdit()"></p-button>
                                        </div>
                                    }
                                </div>
                            </section>

                            <section class="workspace-section span-5">
                                <div class="section-heading">
                                    <i class="pi pi-paperclip"></i>
                                    <div>
                                        <h3>Documents</h3>
                                        <p>{{ purchaseAttachments.length }} files</p>
                                    </div>
                                </div>
                                <div class="attachment-upload-bar">
                                    <p-fileUpload
                                        name="purchaseOrderAttachment"
                                        mode="basic"
                                        [customUpload]="true"
                                        [disabled]="attachmentUploading"
                                        (onSelect)="onPurchaseOrderFileUpload($event)"
                                        chooseLabel="Upload File"
                                        chooseIcon="pi pi-cloud-upload">
                                    </p-fileUpload>
                                    @if (attachmentUploadProgress > 0) {
                                        <p-progressBar [value]="attachmentUploadProgress" [showValue]="true"></p-progressBar>
                                    }
                                </div>
                                @if (purchaseAttachments.length) {
                                    <div class="attachment-list">
                                        @for (file of purchaseAttachments; track file.attachmentId || file.filePath) {
                                            <div class="attachment-row">
                                                <i class="pi pi-file"></i>
                                                <div>
                                                    <strong>{{ file.fileName }}</strong>
                                                    <span>{{ formatFileSize(file.fileSize) }}</span>
                                                </div>
                                                <span class="flex align-items-center gap-1">
                                                    <button pButton pRipple type="button" icon="pi pi-download" class="p-button-rounded p-button-text" aria-label="Download attachment" (click)="downloadAttachment(file)"></button>
                                                    <button *ngIf="showEditAction() && file.attachmentId" pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" aria-label="Remove attachment" pTooltip="Remove attachment" [disabled]="attachmentDeleting" (click)="openAttachmentDelete(file)"></button>
                                                </span>
                                            </div>
                                        }
                                    </div>
                                } @else {
                                    <div class="empty-state">No documents attached to this purchase order.</div>
                                }
                            </section>
                        </div>
                    </section>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </app-page-data-panel>
        </main>

        <aside class="business-action-pane" aria-label="Command Center">
            <header class="business-action-pane__header">
                <span class="business-action-pane__eyebrow">Command Center</span>
                <h2>Purchase Order Actions</h2>
                <p>Manage procurement workflow, approvals, and bills.</p>
            </header>

            <div class="order-locked-notice" *ngIf="isBillGenerated()">
                <i class="pi pi-lock"></i>
                <div>
                    <strong>Order Locked</strong>
                    <span>Vendor bill has been generated. No further modifications are allowed.</span>
                </div>
            </div>

            <section class="business-action-group business-action-group--primary" *ngIf="visibleHeaderLifecycleActions().length > 0">
                <div class="business-action-group__heading">
                    <i class="pi pi-bolt"></i>
                    <div>
                        <strong>Workflow Actions</strong>
                        <span>Lifecycle transitions and approvals</span>
                    </div>
                </div>
                <p-button *ngFor="let action of visibleHeaderLifecycleActions()"
                    [label]="action.label"
                    [icon]="action.icon"
                    [severity]="action.severity"
                    [outlined]="!!action.outlined"
                    (click)="openAction(action.code)"
                    [disabled]="actionLoading"
                    [pTooltip]="blockedReasonFor(action.code)">
                </p-button>
            </section>

            <section class="business-action-group">
                <div class="business-action-group__heading">
                    <i class="pi pi-sliders-h"></i>
                    <div>
                        <strong>Order Management</strong>
                        <span>Edit lines, header details, and project links</span>
                    </div>
                </div>
                <p-button *ngIf="showEditAction()"
                    label="Edit Order"
                    icon="pi pi-pencil"
                    severity="info"
                    (click)="editOrder()"
                    [disabled]="isEditLocked()"
                    [pTooltip]="editLockedTooltip()">
                </p-button>
                <p-button *ngIf="hasLogisticsProject()"
                    label="Linked Project"
                    icon="pi pi-briefcase"
                    severity="secondary"
                    [outlined]="true"
                    (click)="viewLogisticsProject()">
                </p-button>
                <p-button *ngIf="showCreateAction()"
                    label="New Purchase Order"
                    icon="pi pi-plus"
                    severity="help"
                    [outlined]="true"
                    routerLink="/order/purchase-order/add">
                </p-button>
            </section>

            <section class="business-action-group business-action-group--commercial">
                <div class="business-action-group__heading">
                    <i class="pi pi-receipt"></i>
                    <div>
                        <strong>Accounts Payable</strong>
                        <span>Billing and account posting</span>
                    </div>
                </div>
                <p-button
                    label="Post To Accounts"
                    icon="pi pi-file-plus"
                    severity="success"
                    [disabled]="!canPostToAccounts() || payableStagingLoading"
                    (click)="postToAccounts()"
                    [pTooltip]="canPostToAccounts() ? 'Create a payable in To Bill' : 'Resolve readiness blockers before posting to accounts'">
                </p-button>
            </section>
        </aside>
    </div>
</app-page-shell>

<p-dialog [(visible)]="actionDialogVisible" [modal]="true" [style]="{width: '32rem'}" [header]="getActionLabel(pendingAction)">
    <div class="flex flex-column gap-3">
        <label>
            Reason
            <textarea pTextarea [(ngModel)]="actionReason" rows="4" class="w-full" [placeholder]="actionRequiresReason(pendingAction) ? 'Required for this action' : 'Optional comment'"></textarea>
        </label>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [outlined]="true" (click)="actionDialogVisible=false" [disabled]="actionLoading"></p-button>
        <p-button label="Run action" icon="pi pi-check" [loading]="actionLoading" [disabled]="actionLoading" (click)="runAction()"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Remove attachment" [(visible)]="attachmentDeleteDialogVisible" [modal]="true"
    [style]="{width: 'min(42rem, 96vw)'}" styleClass="order-attachment-delete-dialog"
    [draggable]="false" [closable]="!attachmentDeleting" (onHide)="attachmentToDelete=undefined">
    <div class="order-attachment-delete-body">
        <aside class="order-attachment-delete-summary">
            <i class="pi pi-trash"></i>
            <h3>Remove this file?</h3>
            <p>The file will be removed from this order and retained in storage for audit. Your reason will be recorded in the order activity.</p>
        </aside>
        <section class="order-attachment-delete-card">
            <strong>{{ attachmentToDelete?.fileName }}</strong>
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-comment"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <textarea id="purchaseAttachmentDeleteReason" pTextarea [(ngModel)]="attachmentDeleteReason" rows="3" maxlength="500" class="w-full" [disabled]="attachmentDeleting"></textarea>
                    <label for="purchaseAttachmentDeleteReason">Reason for removal *</label>
                </p-iftalabel>
            </p-inputGroup>
            <small>Enter a reason so the removal can be reviewed later.</small>
            <small *ngIf="attachmentDeleteError" class="p-error">{{ attachmentDeleteError }}</small>
        </section>
    </div>
    <ng-template pTemplate="footer">
        <div class="order-attachment-delete-footer">
            <p-button label="Cancel" severity="secondary" [outlined]="true" [disabled]="attachmentDeleting" (click)="attachmentDeleteDialogVisible=false"></p-button>
            <p-button label="Remove attachment" icon="pi pi-trash" severity="danger" [loading]="attachmentDeleting"
                [disabled]="!attachmentDeleteReason.trim() || attachmentDeleting" (click)="deleteAttachment()"></p-button>
        </div>
    </ng-template>
</p-dialog>
